var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.232,
    height: 146.318,
    viewBox: "0 0 210.232 146.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1517",
    "data-name": "Rechteck 1517",
    width: 210.014,
    height: 146.318,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1516",
    "data-name": "Rechteck 1516",
    width: 88.826,
    height: 116.25,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3139",
    "data-name": "Gruppe 3139",
    transform: "translate(-70 -79.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3138",
    "data-name": "Gruppe 3138",
    transform: "translate(70 79.514)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3137",
    "data-name": "Gruppe 3137",
    transform: "translate(67.367 24.598)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3136",
    "data-name": "Gruppe 3136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3135",
    "data-name": "Gruppe 3135",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3809",
    "data-name": "Pfad 3809",
    d: "M326.267,95.9h22.87a2.326,2.326,0,0,1,2.326,2.326v111.6a2.326,2.326,0,0,1-2.326,2.326H264.963a2.326,2.326,0,0,1-2.326-2.326V98.222a2.326,2.326,0,0,1,2.326-2.326H272.4",
    transform: "translate(-262.637 -95.896)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3810",
    "data-name": "Pfad 3810",
    d: "M305.255,70.779h11.088v116.25H227.517V70.779h9.76",
    transform: "translate(-99.157 26.89)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3811",
    "data-name": "Pfad 3811",
    d: "M355.189,18.8a10.452,10.452,0,0,0-20.458,0h-8.988V32.548h38.435V18.8Z",
    transform: "translate(-172.187 71.707)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 5.28,
    cy: 5.28,
    r: 5.28,
    transform: "translate(140.197 136.94) rotate(-76.717)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 5.28,
    cy: 5.28,
    r: 5.28,
    transform: "translate(140.197 158.526) rotate(-76.717)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 5.28,
    cy: 5.28,
    r: 5.28,
    transform: "translate(141.269 170.906)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_363",
    "data-name": "Linie 363",
    x2: 38.082,
    transform: "translate(158.878 130.079)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_364",
    "data-name": "Linie 364",
    x2: 20.043,
    transform: "translate(158.878 135.949)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_365",
    "data-name": "Linie 365",
    x2: 38.082,
    transform: "translate(158.878 151.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_366",
    "data-name": "Linie 366",
    x2: 20.043,
    transform: "translate(158.878 157.535)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_367",
    "data-name": "Linie 367",
    x2: 38.082,
    transform: "translate(158.878 173.251)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_368",
    "data-name": "Linie 368",
    x2: 20.043,
    transform: "translate(158.878 179.121)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_370",
    "data-name": "Linie 370",
    y1: 12.551,
    x2: 12.551,
    transform: "translate(250.928 90.731)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_372",
    "data-name": "Linie 372",
    x1: 6.275,
    y1: 6.275,
    transform: "translate(244.653 97.006)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3812",
    "data-name": "Pfad 3812",
    d: "M772.032,176.272a7.2,7.2,0,1,1-7.2-7.2A7.2,7.2,0,0,1,772.032,176.272Z",
    transform: "translate(-493.301 -46.193)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3813",
    "data-name": "Pfad 3813",
    d: "M25.432,397.672a1.3,1.3,0,0,1-.921-2.214l0,0,1.571-1.566a1.3,1.3,0,0,1,1.833,0l0,0a1.3,1.3,0,0,1,0,1.833l0,0-1.566,1.566a1.29,1.29,0,0,1-.921.381",
    transform: "translate(52.058 -213.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3814",
    "data-name": "Pfad 3814",
    d: "M1.3,421.807a1.3,1.3,0,0,1-.917-2.217l1.566-1.566a1.3,1.3,0,1,1,1.837,1.836l-1.572,1.566a1.3,1.3,0,0,1-.914.381",
    transform: "translate(69.996 -231.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3815",
    "data-name": "Pfad 3815",
    d: "M26.989,421.813a1.3,1.3,0,0,1-.917-.381L24.5,419.866a1.3,1.3,0,0,1,0-1.833l0,0a1.3,1.3,0,0,1,1.837,0L27.9,419.6a1.3,1.3,0,0,1-.914,2.218",
    transform: "translate(52.067 -231.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3816",
    "data-name": "Pfad 3816",
    d: "M2.866,397.673a1.294,1.294,0,0,1-.919-.381L.38,395.726a1.3,1.3,0,0,1,0-1.833l0,0a1.3,1.3,0,0,1,1.837,0l1.566,1.566a1.3,1.3,0,0,1,0,1.833l0,0a1.286,1.286,0,0,1-.917.381",
    transform: "translate(70 -213.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3817",
    "data-name": "Pfad 3817",
    d: "M690.095,285.221a1.3,1.3,0,0,1-.921-2.214l0,0,1.571-1.566a1.3,1.3,0,0,1,1.833,0l0,0a1.3,1.3,0,0,1,0,1.833v0l-1.567,1.566a1.289,1.289,0,0,1-.921.38",
    transform: "translate(-442.116 -129.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3818",
    "data-name": "Pfad 3818",
    d: "M665.966,309.355a1.3,1.3,0,0,1-.917-2.217l1.566-1.566a1.3,1.3,0,0,1,1.836,1.836l-1.571,1.566a1.3,1.3,0,0,1-.914.381",
    transform: "translate(-424.178 -147.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3819",
    "data-name": "Pfad 3819",
    d: "M691.653,309.362a1.3,1.3,0,0,1-.917-.381l-1.571-1.566a1.3,1.3,0,0,1,0-1.833h0a1.3,1.3,0,0,1,1.837,0l1.566,1.564a1.3,1.3,0,0,1-.914,2.218",
    transform: "translate(-442.108 -147.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3820",
    "data-name": "Pfad 3820",
    d: "M667.529,285.221a1.293,1.293,0,0,1-.919-.38l-1.567-1.566a1.3,1.3,0,0,1,0-1.833l0,0a1.3,1.3,0,0,1,1.837,0l1.567,1.566a1.3,1.3,0,0,1,0,1.833v0a1.285,1.285,0,0,1-.917.38",
    transform: "translate(-424.174 -129.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3821",
    "data-name": "Pfad 3821",
    d: "M117.557,297.291a1.3,1.3,0,0,1-.921-2.214l0,0,1.571-1.566a1.3,1.3,0,0,1,1.833,0l0,0a1.3,1.3,0,0,1,0,1.833l0,0-1.566,1.566a1.29,1.29,0,0,1-.921.381",
    transform: "translate(-16.437 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3822",
    "data-name": "Pfad 3822",
    d: "M93.428,321.425a1.3,1.3,0,0,1-.917-2.217l1.566-1.566a1.3,1.3,0,1,1,1.837,1.836l-1.572,1.566a1.3,1.3,0,0,1-.914.381",
    transform: "translate(1.502 -156.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3823",
    "data-name": "Pfad 3823",
    d: "M119.115,321.432a1.3,1.3,0,0,1-.917-.381l-1.571-1.566a1.3,1.3,0,0,1,0-1.834h0a1.3,1.3,0,0,1,1.837,0l1.566,1.564a1.3,1.3,0,0,1-.914,2.218",
    transform: "translate(-16.428 -156.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3824",
    "data-name": "Pfad 3824",
    d: "M94.991,297.292a1.294,1.294,0,0,1-.919-.381l-1.566-1.566a1.3,1.3,0,0,1,0-1.833l0,0a1.3,1.3,0,0,1,1.837,0l1.566,1.566a1.3,1.3,0,0,1,0,1.833l0,0a1.286,1.286,0,0,1-.917.381",
    transform: "translate(1.506 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_373",
    "data-name": "Linie 373",
    y1: 12.551,
    x2: 12.551,
    transform: "translate(94.657 205.715)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_374",
    "data-name": "Linie 374",
    x1: 6.275,
    y1: 6.275,
    transform: "translate(88.382 211.991)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyHero);
export default __webpack_public_path__ + "static/media/survey_hero.8803bdcd9d7eabd9c29979540ac93484.svg";
export { ForwardRef as ReactComponent };